<template>
    <Button v-bind="$props" :color="color" iconPosition="left" :font="font">
        <slot />
    </Button>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import Button, { buttonProps } from './Button.vue';

    export default defineComponent({
        name: 'ButtonImportant',
        components: { Button },
        props: {
            ...buttonProps,
            color: { type: String as PropType<'pop' | 'primary' | 'jungle'>, default: 'pop' },
        },
        setup(props) {
            const font = computed(() => {
                switch (props.size) {
                    case 'l':
                        return 'font-button-large';
                    case 'm':
                        return 'font-button-medium';
                    default:
                        return 'font-button-small';
                }
            });

            return { font };
        },
    });
</script>
